














import { useCustomersStore } from "@/store/useCustomersStore";
import { defineComponent } from "@vue/composition-api";
import { BBadge } from "bootstrap-vue";
import { storeToRefs } from "pinia";

export default defineComponent({
    components: {
        BBadge,
    },
    setup() {
        const { customerSettings } = storeToRefs(useCustomersStore());
        return {
            customerSettings,
        };
    },
});
